import {userProfile$} from '../api';

export const getAccessToken = () => userProfile$?.value?.accessToken ?? '';

export const getAccessToken$ = () => userProfile$.map(({accessToken}) => accessToken ?? '').distinctUntilChanged();
